import React from "react";
import { ArrowLeft, Trash2, FolderOpen, User, Car, Home, Phone, Copy, StickyNote, Trash } from "lucide-react";

export default function ListView({ records, onBack, onDeleteAll, onDelete, onOpenCard, onCopy }) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <button
          onClick={onBack}
          className="text-xs bg-slate-800 text-slate-300 hover:text-white px-3 py-1.5 rounded-lg border border-slate-700 flex items-center gap-1.5 transition-colors"
        >
          <ArrowLeft size={12} /> Geri Dön
        </button>
        <div className="flex gap-2">
          <button
            onClick={onDeleteAll}
            className="bg-red-500/10 hover:bg-red-500/20 text-red-400 text-xs px-3 py-1.5 rounded-lg border border-red-500/30 font-medium flex items-center gap-1.5 transition-colors"
          >
            <Trash2 size={12} /> Hepsini Sil
          </button>
        </div>
      </div>

      <div className="space-y-3">
        {records.length === 0 ? (
          <div className="bg-slate-800/50 border border-slate-700/60 rounded-2xl p-8 text-center">
            <div className="text-slate-600 mb-2 flex justify-center">
              <FolderOpen size={30} />
            </div>
            <p className="text-slate-400 text-xs">Sistemde henüz kayıtlı kişi bulunmuyor.</p>
          </div>
        ) : (
          records.map((item) => (
            <div
              key={item.id}
              className="bg-slate-800 border border-slate-700/80 rounded-2xl p-4 shadow-md flex flex-col gap-3 relative overflow-hidden mt-2"
            >
              <div className="absolute top-0 right-0 bg-brand-600/20 text-brand-400 text-sm px-4 py-1.5 rounded-bl-xl font-bold border-l border-b border-brand-500/20 flex items-center gap-1.5">
                <span className="text-[10px] font-sans opacity-70 uppercase tracking-widest">Plaka</span>
                <span className="font-mono">{item.plateNo}</span>
              </div>

              <div className="flex items-start gap-3 pt-3">
                <div className="w-10 h-10 rounded-xl bg-slate-700 text-brand-400 flex items-center justify-center font-bold text-sm shadow-inner shrink-0 border border-slate-600">
                  <User size={16} />
                </div>

                <div className="flex-1 pr-24 cursor-pointer group" onClick={() => onOpenCard(item.id)}>
                  <h4 className="font-bold text-white text-sm group-hover:text-brand-400 transition-colors">
                    {item.fullName}{" "}
                    <span className="text-[11px] bg-slate-700 text-slate-300 px-2 py-0.5 rounded-full ml-1">
                      {item.relationDegree}
                    </span>
                  </h4>
                  <p className="text-xs text-slate-400 mt-0.5 flex items-center gap-1">
                    <Car size={10} />
                    {item.carModel}
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-2 text-xs bg-slate-900/60 p-2.5 rounded-xl border border-slate-700/50">
                <div className="text-slate-300 flex items-center gap-1.5">
                  <Home size={11} className="text-slate-500" /> Daire:{" "}
                  <span className="font-medium text-white">{item.aptNo}</span>
                </div>
                <div className="text-slate-300 flex items-center justify-between col-span-1">
                  <span className="flex items-center gap-1.5">
                    <Phone size={11} className="text-slate-500" /> Tel:{" "}
                    <span className="font-medium text-white">{item.phoneNo}</span>
                  </span>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onCopy(item.phoneNo);
                    }}
                    className="bg-slate-700 hover:bg-slate-600 text-brand-400 p-1.5 rounded-md transition-colors active:scale-95"
                    title="Kopyala"
                  >
                    <Copy size={12} />
                  </button>
                </div>
              </div>

              {item.infoNote ? (
                <div className="text-xs text-slate-300 bg-slate-950/50 p-2 rounded-xl border border-slate-700/50 line-clamp-2 flex items-start gap-1">
                  <StickyNote size={11} className="text-slate-500 mt-0.5 shrink-0" />
                  <span>{item.infoNote}</span>
                </div>
              ) : null}

              <div className="flex items-center justify-end pt-1">
                <button
                  onClick={() => onDelete(item.id)}
                  className="text-xs bg-red-500/10 hover:bg-red-500/20 text-red-400 px-3 py-1.5 rounded-lg border border-red-500/20 font-medium flex items-center gap-1 transition-colors"
                >
                  <Trash size={10} /> Sil
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
